module.exports = __webpack_public_path__ + "static/media/war_intro_screen.874d343e.png";